import React from "react";
import SEO from "../components/SEO";
import Header from "../partials/header/Header";
import Breadcrumb from "../container/Breadcrumb/Breadcrumb";
// import HomeAbout from '../components/About/HomeAbout.jsx';

// import AboutFive from '../container/About/AboutFive';
// import TestimonialContainer from '../container/Testimonial/TestimonialContainer';
import Footer from "../container/Footer/Footer";
import ScrollToTop from "../components/ScrollToTop.jsx";
import EmptyTwo from "../container/Empty/EmptyTwo";
// import { Link } from "react-router-dom";
// import NewGif from "../components/Gif/NewGif";

// import EmptyOne from '../container/Empty/EmptyOne';

const Proceedings = () => {
  return (
    <React.Fragment>
      <SEO title="Proceedings | DMBD 2024" />
      <Header />
      <Breadcrumb
        image="images/bg/banner2.jpg"
        title="Proceedings"
        content="The Conference"
        contentTwo="Proceedings"
        linkage="/"
      />

      <EmptyTwo>
        <h2>Proceedings Download</h2>
        
        <div className="space-60"></div>
        <div className="access">
            Note: The ICSI&apos;2022 Proceedings (Springer-Nature LNCS 13344 and LNCS 13345) are available online for all participants to download, for free, from July 08, 2022 to August 08, 2022.
        </div>
        <div className="space-60"></div>
        <br></br>
        <br></br>
        <div className="fontlarger">

        {/* <h4>Download from our :</h4> */}
        <br></br>


        <a href="https://link.springer.com/book/10.1007/978-3-031-09677-8">Advances in Swarm Intelligence, Proceedings,  Part I</a>
        <div className="space-40"></div>

        <a href="https://link.springer.com/book/10.1007/978-3-031-09726-3">Advances in Swarm Intelligence, Proceedings,  Part II</a>

        </div>

        <div className="space-60"></div>

        <h4>Download directly from our website:</h4>
        <div className="space-40"></div>


        <div className="down-pic">
          <a href="./files/2022_Book_AdvancesInSwarmIntelligence-part1.pdf">
          <img width={400} src="./images/program/proceedings_1.jpg"></img>
          </a>
          <div className="space-60"></div>
          <a href="./files/2022_Book_AdvancesInSwarmIntelligence-part2.pdf">
          <img width={400} src="./images/program/proceedings_2.jpg"></img>
          </a>



        </div>


      </EmptyTwo>
      {/* <AboutFive />
            <TestimonialContainer classOption="bg-primary-blue" />
            <CallToActionTwo /> */}
      <Footer />
      <ScrollToTop />
    </React.Fragment>
  );
};

export default Proceedings;
